import { useFormikContext } from 'formik';
import { PredictionView } from 'modules/Playground/vision/PredictionView';
import { FC } from 'react';
import { ModelContextProvider } from 'modules/Models/components/ModelContext/ModelContextProvider';
import { ModelVersionsContextProvider } from 'modules/Models/components/ModelVersionsContext/ModelVersionsContextProvider';
import { MstPredictionStoreCtxProvider } from 'modules/Predictions/contexts/MstPredictionStoreCtxProvider';
import { queryKeys, useQueryTE } from 'utils/react-query';
import { modelPageApiEffects } from 'modules/Models/apiEffects';
import { listModelVersionsTE } from 'api/models/listModelVersions';
import { errorToReactLeft } from 'utils/fp';
import { pipe } from 'fp-ts/lib/function';
import { either } from 'fp-ts';
import { PlaygroundConfig } from '../types/playgroundConfig';

export const VisionComponent: FC = () => {
  const { values } = useFormikContext<PlaygroundConfig>();
  const appId = values.model?.app_id ?? '';
  const userOrOrgId = values.model?.user_id ?? '';
  const modelId = values.model?.id ?? '';

  const { data: refetchedModelE } = useQueryTE(
    [queryKeys.Models, { appId, userOrOrgId, modelId }],
    modelPageApiEffects.fetchModelTE(modelId, appId, userOrOrgId, 'additional_fields=stars&additional_fields=presets'),
    {
      keepPreviousData: true,
    },
  );

  const { data: modelVersionsE } = useQueryTE(
    [queryKeys.ModelVersions, { appId, userOrOrgId, modelId }],
    listModelVersionsTE({ modelId, appId, userId: userOrOrgId }, errorToReactLeft),
    {
      keepPreviousData: true,
    },
  );

  const refetchedModel = pipe(
    refetchedModelE,
    either.getOrElseW(() => undefined),
  );

  const modelVersions = pipe(
    modelVersionsE,
    either.getOrElseW(() => undefined),
  );

  if (!modelVersions || !refetchedModel) {
    return null;
  }

  return (
    <ModelContextProvider modelE={refetchedModelE}>
      <ModelVersionsContextProvider modelVersionsE={modelVersionsE}>
        <MstPredictionStoreCtxProvider>
          <PredictionView
            userAndAppIds={{
              appId,
              userOrOrgId,
            }}
            disableRouterUpdates
          />
        </MstPredictionStoreCtxProvider>
      </ModelVersionsContextProvider>
    </ModelContextProvider>
  );
};
